import React from "react";
import CampaignsDashboard from "../../components/campaigns/CampaignsDashboard";

const CampaignsPage = () => <CampaignsDashboard />;

export default CampaignsPage;
